import { Component, OnInit } from '@angular/core';

import {Inject} from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_services/user.service';

@Component({
    selector: 'user-verify',
    templateUrl: 'userVerify.component.html'
    
})
export class UserVerifyComponent implements OnInit {
    constructor(private userService: UserService,
                 private _router:Router) {}
     ngOnInit()  {
        
         const parameters = this._router.url;
         console.log(this._router.url);
          
         if (parameters.indexOf('verifykey') > 0) {
            const key = this._router.url.split('verifykey=')[1];
            this.userService.verifyUser(key);
        }
     } 
}
